module.exports = __webpack_public_path__ + "img/transfer-delete.f06ea875.svg";